const apiUrl = process.env.REACT_APP_API_URL;
export const PostPantalles = async ( id : number | null, nom : string, descripcio : string, subpagines : string, contenedor : string, extensio : string | null, pantalla : string, tipus : boolean, page : string, id_usu_log : string  ) => {
    try {
        const response = await fetch(`${apiUrl}:8071/pantalles/${id_usu_log}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({id, nom, descripcio, subpagines, contenedor, extensio, pantalla, tipus})
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};